import React, { useContext } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useNavigate } from "react-router-dom";
import logoCoralie from '../../../src/assets/Logo_coralie.png';
import './NavBar.scss'
import { decode } from "html-entities";
import { useSelector } from "react-redux";
import { getFirstAndLastNames, isAdminKc } from "../../utils/keycloakUtils";


export default function NavBar({
    keycloak,
    setIsAppLoading,
}) {

    const {
        keycloakReduce,
        mnhPratique,
    } = useSelector(state => ({
        ...state.keycloakReducer,
        ...state.resourcesReducer,
    }))

    const navigate = useNavigate();

    const CONF = window?.confPub;
    const ROUTES_PAGES = CONF?.ROUTES?.PAGES;
    const LINK_LABEL = CONF?.LINK_LABEL;

    const logout = (e) => {
        e.preventDefault();

        setIsAppLoading(true)

        // localStorage.removeItem('accessToken')
        localStorage.removeItem('alreadyLoggedIn')

        // Evite les redirections si on se relog ensuite
        navigate(ROUTES_PAGES?.ROOT)

        keycloak.logout().then(res => {

            setIsAppLoading(false)
            console.log('logout res')
            console.log(res)

        }).catch(err => {

            setIsAppLoading(false)
            console.log('logout err')
            console.log(err)
        })
    }

    return (
        <div className='nav-bar-coralie'>

            <div id="skipnav">
                <div className='container'>
                    <a href="#content">Aller au contenu</a>
                </div>
            </div>

            <Navbar bg="coralie-theme" variant="dark" expand="xxl">
                <Container fluid={ true }>

                    { keycloakReduce?.decodedToken && !keycloakReduce?.decodedToken?.neverLoggedIn ? (<>
                        <Navbar.Brand onClick={ () => navigate(ROUTES_PAGES?.ROOT) } className='hover-click'>
                            <div className="nav-item">
                                <img
                                    src={ logoCoralie }
                                    height="60"
                                    alt="Logo Coralie"
                                    className="nav-image"

                                />
                                <span className="nav-text nav-link">Accueil</span>
                            </div>
                        </Navbar.Brand>
                    </>) : (<>
                        <Navbar.Brand>
                            <div className="nav-item">
                                <img
                                    src={ logoCoralie }
                                    height="60"
                                    alt="Logo Coralie"
                                />
                            </div>
                        </Navbar.Brand>
                    </>) }

                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">

                        <Nav className="ms-auto">
                            {/*TODO Check if a user can toggle neverLoggedIn from storage console / JS*/}
                            { keycloakReduce?.decodedToken && !keycloakReduce?.decodedToken?.neverLoggedIn ? (<>
                                <Nav.Link onClick={ () => navigate(ROUTES_PAGES?.INFOS_GENERALES) }>
                                    { LINK_LABEL?.ROUTES?.INFOS_GENERALES }
                                </Nav.Link>
                                <Nav.Link onClick={ () => navigate(ROUTES_PAGES?.RECHERCHE_PERSONNE) }>
                                    { LINK_LABEL?.ROUTES?.RECHERCHE_PERSONNE }
                                </Nav.Link>
                                <Nav.Link
                                    href="#"
                                    onClick={ () => navigate(ROUTES_PAGES?.ANNUAIRE_CORRESPONDANTS) }>
                                    { LINK_LABEL?.ROUTES?.ANNUAIRE_CORRESPONDANTS }
                                </Nav.Link>

                                <NavDropdown title={ LINK_LABEL?.ROUTES?.MNH_PRATIQUE } id="basic-nav-dropdown">

                                    { mnhPratique?.length > 0 && mnhPratique.map((page, key) => {
                                        return (
                                            <NavDropdown.Item
                                                key={ key }
                                                onClick={ () => navigate(`/mnh-pratique${ page?.pageUrl }`) }
                                            >
                                                { decode(page?.pageLibelle) }
                                            </NavDropdown.Item>
                                        )
                                    }) }
                                </NavDropdown>

                                { isAdminKc(keycloakReduce?.decodedToken) ? (<>
                                    <NavDropdown title={ LINK_LABEL?.ROUTES?.ADMINISTRATION_CONTENU } id="basic-nav-dropdown">
                                        <NavDropdown.Item
                                            onClick={ () => navigate(ROUTES_PAGES?.ADMIN?.AJOUTER_MODIFIER_MSG_ACCUEIL) }
                                        >
                                            { LINK_LABEL?.ROUTES?.AJOUTER_MODIFIER_MSG_ACCUEIL }
                                        </NavDropdown.Item>
                                        <NavDropdown.Item
                                            onClick={ () => navigate(ROUTES_PAGES?.ADMIN?.AJOUTER_CONTRIBUTION) }
                                        >
                                            { LINK_LABEL?.ROUTES?.AJOUTER_CONTRIBUTION }
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </>) : '' }

                                <NavDropdown
                                    title={ `Bonjour ${ getFirstAndLastNames(keycloakReduce?.decodedToken) }` }
                                    id="basic-nav-dropdown"
                                >
                                    <NavDropdown.Item
                                        onClick={ () => navigate(ROUTES_PAGES?.PROFIL?.MAIN) }
                                    >
                                        { LINK_LABEL?.ROUTES?.PROFIL }
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider/>
                                    {/*<NavDropdown.Item href="#action/2.3">*/}
                                    {/*    Changer mot de passe*/}
                                    {/*</NavDropdown.Item>*/}
                                    <NavDropdown.Item onClick={ logout }>
                                        Se déconnecter
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </>) : (<>
                                <NavDropdown
                                    title={ `Bonjour ${ getFirstAndLastNames(keycloakReduce?.decodedToken) }` }
                                    id="basic-nav-dropdown"
                                >
                                    <NavDropdown.Item onClick={ logout }>
                                        Se déconnecter
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </>) }
                        </Nav>

                        {/*<Form className="d-flex me-4 align-items-center">*/ }
                        {/*    <Form.Control*/ }
                        {/*        type="search"*/ }
                        {/*        placeholder="RecherchePersonne"*/ }
                        {/*        className="me-2"*/ }
                        {/*        aria-label="Search"*/ }
                        {/*    />*/ }
                        {/*    <Button variant="primary" className="m-0">Rechercher</Button>*/ }
                        {/*</Form>*/ }
                    </Navbar.Collapse>

                    {/*<FaSun/>*/ }
                    {/*/!*Debut d'un thème jour/nuit*!/*/ }
                    {/*<Form.Check*/ }
                    {/*    type="switch"*/ }
                    {/*    id="custom-switch"*/ }
                    {/*    label= ""*/ }
                    {/*    onClick={handleTheme}*/ }
                    {/*    // defaultChecked ={props.theme}*/ }
                    {/*    value = {data.sombre}*/ }
                    {/*/>*/ }
                    {/*<FaMoon/>*/ }
                </Container>
            </Navbar>
        </div>
    )
}

